import { useEffect, useState } from "react";
import bookingApi from "../../api/booking/booking";
import clientsApi from "../../api/client/client";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { ui } from "../../helpers/ui";

const InitBookLogic = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [bookings, setBookings] = useState<any[]>([]);

  const [client, setClient] = useState<any>();

  const [location, setLocation] = useState<string>("Centar");

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const locations = ["Centar", "Radnička"];

  const [clients, setClients] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [data, setData] = useState<any>({
    client: "",
  });

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const selectClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza
    if (selectedClient?.id === client.id) return;
    const rest = clients.filter((c: any) => c.id !== client.id);
    setClients(selectedClient !== undefined ? [...rest, selectedClient] : rest);
    setSelectedClient(client);
    // setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    setSelectedClient(undefined);
    setClients([...clients, client]);
    setData({ ...data, client: "" });
  };

  useEffect(() => {
    loadClients();
  }, []);

  const loadClient = () => {
    clientsApi
      .getByIdWithBookings(selectedClient.userId, location)
      .then((response) => {
        if (response.status === 200) {
          setClient(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    if (selectedClient) loadClient();
    else {
      setClient(null);
      setSelectedDate(null);
    }
  }, [selectedClient]);

  useEffect(() => {
    loadBookings();
  }, []);

  useEffect(() => {
    loadBookings();
    if (selectedClient) loadClient();
    else {
      setClient(null);
      setSelectedDate(null);
    }
  }, [location]);

  const loadBookings = () => {
    setIsLoading(true);
    bookingApi
      .getBookingsForClients(location)
      .then((response) => {
        if (response.status === 200) {
          const sortedData = response.data.sort(
            (a: any, b: any) =>
              new Date(a.date).getTime() - new Date(b.date).getTime()
          );
          setBookings(sortedData);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onBook = (data: any) => {
    bookingApi
      .bookAll(data, location, selectedClient.userId)
      .then(() => {
        loadBookings();
        loadClient();
      })
      .catch((e) => {
        loadBookings();
        loadClient();
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onCancel = (id: number) => {
    bookingApi
      .cancelByClientId({ id }, selectedClient.id)
      .then(() => {
        loadBookings();
        loadClient();
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChangeLocation = (event: any) => {
    setBookings([]);
    setClient(null);
    setLocation(event.target.value);
    setSelectedDate(null);
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  return {
    selectedDate,
    client,
    bookings,
    locations,
    clients,
    selectedClient,
    data,
    isLoading,
    setSelectedDate,
    onBook,
    onCancel,
    onChangeLocation,
    selectClient,
    removeSelectedClient,
    onChange,
  };
};

export default InitBookLogic;
